// @flow
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { MultiSelect } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import useIntl from '../../../hooks/useIntl';
import intlMessages from '../messages';

type Props = {|
  selectedHouseholdStatuses: string[],
  onChange: (householdStatuses: string[]) => void,
|};

const HOUSEHOLD_STATUS_OPTIONS = [
  { value: 'PROSPECT', label: intlMessages.prospectStatus },
  { value: 'APPLICANT', label: intlMessages.applicantStatus },
  { value: 'RESIDENT', label: intlMessages.residentStatus },
  { value: 'PRIOR_RESIDENT', label: intlMessages.priorResidentStatus },
];

function HouseholdStatusFilter({
  selectedHouseholdStatuses,
  onChange,
}: Props): React$Node {
  const intl = useIntl();
  const options = useMemo(
    () =>
      HOUSEHOLD_STATUS_OPTIONS.map((option) => ({
        value: option.value,
        text: intl.formatMessage(option.label),
      })),
    [intl],
  );

  return (
    <Box mb={2} width={300}>
      <MultiSelect
        value={selectedHouseholdStatuses}
        onChange={onChange}
        options={options}
        placeholder={intl.formatMessage(intlMessages.allStatuses)}
        fullWidth
        label={<FormattedMessage {...intlMessages.filterByHouseholdStatus} />}
      />
    </Box>
  );
}

export default HouseholdStatusFilter;
